import { DndElementsType } from "alurkerja-ui";
import { Code2, FileUp, LucideLetterText } from "lucide-react";
import { MdHorizontalRule } from "react-icons/md";
import { PiArrowsOutLineVerticalBold } from "react-icons/pi";

const customDndElemets: DndElementsType[] = [
  {
    label: 'Spacer',
    type_element: 'layout',
    icon: <PiArrowsOutLineVerticalBold />,
    category: 'Layout',
    config: {
      ui_type: 'LAYOUT_SPACER',
      height: '20px',
    },
  },
  {
    label: 'Separator',
    type_element: 'layout',
    icon: <MdHorizontalRule />,
    category: 'Layout',
    config: {
      ui_type: 'LAYOUT_SEPARATOR',
    },
  },
  {
    label: 'Rich Text',
    type_element: 'input',
    icon: <LucideLetterText />,
    category: 'Layout',
    config: {
      ui_type: 'INPUT_RICH_TEXT',
      label: { en: 'Rich Text', id: 'Rich Text' },
      name: 'rich_text_' + Math.floor(Math.random() * 1000),
      tooltip: {
        enable: false,
        message: '',
      },
      disabled: false,
    },
  },
  {
    label: 'File Upload',
    type_element: 'input',
    icon: <FileUp />,
    category: 'Input',
    config: {
      ui_type: 'INPUT_FILE_UPLOAD',
      label: { en: 'File Upload', id: 'Unggah Berkas' },
      name: 'file_upload_' + Math.floor(Math.random() * 1000),
      tooltip: {
        enable: false,
        message: '',
      },
      disabled: false,
      multiple_file: false,
      max_file_size: 1, // in MB
      extensions: 'jpg,png,pdf,docx,xlsx',
    },
  },
  {
    label: 'HTML Custom',
    type_element: 'technical',
    icon: <Code2 />,
    category: 'Input',
    config: {
      ui_type: 'HTML_CUSTOM_FORM',
      label: { en: 'HTML Custom Form', id: 'Formulir Kustom HTML' },
      name: 'html_custom_form_' + Math.floor(Math.random() * 1000),
      edit_tabs: {
        content: {
          html_content: null,
        },
      },
    },
  },
  {
    label: 'Iframe Custom',
    type_element: 'technical',
    icon: <Code2 />,
    category: 'Input',
    config: {
      ui_type: 'IFRAME_CUSTOM_FORM',
      label: { en: 'Iframe Custom Form', id: 'Formulir Kustom Iframe' },
      name: 'iframe_custom_form_' + Math.floor(Math.random() * 1000),
      url: '',
      height: '500px',
      width: '100%',
      disabled: false,
    },
  },
  {
    label: 'Shadow Embed',
    type_element: 'technical',
    icon: <Code2 />,
    category: 'Input',
    config: {
      ui_type: 'SHADOW_EMBED',
      label: { en: 'Shadow Embed Form', id: 'Formulir Shadow Embed' },
      name: 'shadow_embed_form_' + Math.floor(Math.random() * 1000),
      shadow_embed_id: -9999,
      height: '500px',
      width: '100%',
      disabled: false,
    },
  },
  {
    label: 'Micro Frontend',
    type_element: 'technical',
    icon: <Code2 />,
    category: 'Input',
    config: {
      ui_type: 'EXTERNAL_MICRO_FRONTEND_FORM',
      label: { en: 'External Micro Frontend Form', id: 'Formulir Micro Frontend Eksternal' },
      name: 'external_micro_frontend_form_' + Math.floor(Math.random() * 1000),
      url: '',
      component_scope: '',
      component_name: '',
      height: '500px',
      width: '100%',
      disabled: false,
      edit_tabs: {
        mfeConfig: {
          additional_mfe_config: {}
        },
      },
    },
  },
  {
    label: 'Remote Select',
    type_element: 'input',
    icon: <Code2 />,
    category: 'Input',
    config: {
      ui_type: 'REMOTE_SELECT',
      label: { en: 'Remote Select', id: 'Pilih Melalui URL' },
      name: 'remote_select_' + Math.floor(Math.random() * 1000),
      data_url: '',
      root_data: 'contents',
      select_remote_value_field: 'id',
      select_remote_label_field: 'name',
      disabled: false,
    },
  },
  {
    label: 'Remote Multiple Select',
    type_element: 'input',
    icon: <Code2 />,
    category: 'Input',
    config: {
      ui_type: 'REMOTE_MULTI_SELECT',
      label: { en: 'Remote Multiple Select', id: 'Pilih Melalui URL' },
      name: 'remote_select_' + Math.floor(Math.random() * 1000),
      data_url: '',
      root_data: 'contents',
      select_remote_value_field: 'id',
      select_remote_label_field: 'name',
      disabled: false,
    },
  },
  {
    label: 'Master Data Select',
    type_element: 'input',
    icon: <Code2 />,
    category: 'Input',
    config: {
      ui_type: 'REMOTE_MASTERDATA_SELECT',
      label: { en: 'Master Data Select', id: 'Pilih Master Data' },
      name: 'masterdata_select_' + Math.floor(Math.random() * 1000),
      masterdata_slug: '',
      select_value_field: 'id',
      select_label_field: 'name',
    },
  }
];

export const useUiPicker = () => {
  return {
    customDndElemets
  };
}
